import React from 'react';

const HeartIcon = (props) => {
  if (props.user.heart) {
    return (<i className="fas fa-heart fa-lg"></i>);
  } else {
    return (<i className="fal fa-heart fa-lg"></i>);
  }
}
export default HeartIcon;